import React from "react"
import PropTypes from "prop-types"
export const AlertIcon = ({ height = 24, width = 24, fill = "#272A34", ...props }) => {
  const themeColor = "var(--color-primary)"
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.57563 3.21635L1.51729 14.9997C1.37177 15.2517 1.29477 15.5374 1.29395 15.8284C1.29314 16.1195 1.36854 16.4056 1.51265 16.6585C1.65676 16.9113 1.86457 17.122 2.11538 17.2696C2.3662 17.4171 2.65129 17.4965 2.94229 17.4997H17.059C17.35 17.4965 17.6351 17.4171 17.8859 17.2696C18.1367 17.122 18.3445 16.9113 18.4886 16.6585C18.6327 16.4056 18.7081 16.1195 18.7073 15.8284C18.7065 15.5374 18.6295 15.2517 18.484 14.9997L11.4256 3.21635C11.2771 2.97144 11.0679 2.76895 10.8183 2.62842C10.5687 2.48789 10.2871 2.41406 10.0006 2.41406C9.71418 2.41406 9.43257 2.48789 9.18296 2.62842C8.93336 2.76895 8.72419 2.97144 8.57563 3.21635Z"
        stroke={themeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10 7.5V10.8333" stroke={themeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 14.168H10.0083" stroke={themeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

AlertIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  fill: PropTypes.string
}
